import React,{useEffect} from 'react';
import Logo from '../../components/common/Logo';
import LoginForm from '../../components/Auth/LoginForm';
import {useNavigate, useLocation} from 'react-router-dom';
import {loginUser} from '../../actions/LoginActions';
import swal from 'sweetalert'


function Login(){
   const location = useLocation();
        useEffect(() => {
            window.gtag("config", "UA-185641939-1", {
            page_title: location.pathname,
            page_path:location.pathname,
            })
          }, [location]);
          
            useEffect(() => {
              window.gtag("config", "GTM-WD9H59N", {
              page_title: location.pathname,
              page_path:location.pathname,
              })
          }, [location]);
    

    const navigate = useNavigate();
    useEffect(() => {
        if(sessionStorage.getItem('userDetail')){
            navigate('/dashboard');
        }
    },[]);
    
    const onSubmit=(model)=>{
        loginUser(model).then(res => {
            if (res.status) {
                navigate('/dashboard');
            }
            else{
                swal(res.message,'','error')
            }
        })
        
    }
    return(
       <>
       <section className="py-5 login-page">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                    <div className="text-center">
                    <Logo alt="Logo"/>
                    </div>
                    <div className="login-box">
                        <div className="page-head">
                            <h2>Student Login</h2>
                        </div>
                        <LoginForm onSubmit={onSubmit}/>
                    </div>
                </div>
            </div>
        </div>
    </section>
       </>
    );
}

export default Login;



